import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ValidacionClienteService } from '../services/validacion-cliente.service';

@Injectable({
  providedIn: 'root'
})
export class TokenGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly validacionClienteSrv: ValidacionClienteService
  ) {}
  canActivate(): boolean | UrlTree {
    if (!!this.validacionClienteSrv.cifrado) {
      return true;
    } else {
      this.router.navigate(['/estado-situacion/login-eess']);
      return false;
    }
  }
}
